import React from "react";
import { Field } from "formik";
import { TextField } from "@mui/material";
import { capitalizeText } from "../utils/text";

export default function CapitalizedFormikField(props) {
  const { name, ...rest } = props;

  return (
    <Field name={name}>
      {({ field, form, meta }) => (
        <TextField
          {...field}
          {...rest}
          error={meta.touched && !!meta.error}       // Hata durumu
          helperText={meta.touched && meta.error}    // Hata mesajı
          onChange={(e) => {
            const formatted = capitalizeText(e.target.value);
            form.setFieldValue(name, formatted);
          }}
        />
      )}
    </Field>
  );
}
